import React, { Component } from 'react';
import '../assets/custom.css';
import logo_picturenaming from "../assets/images/app-picturenaming.png";
import logo_wordsignsay from "../assets/images/app-wordsignsay.png";
import logo_copyright from "../assets/images/app-copyright.png";
import logo_kidsign from "../assets/images/app-kidsignsay.png";
import {VideoComponent} from "../StudentsComponent/Common";

import Header from "../HomeHeaderComponent/HomeHeader";

var logo_maze = require('../assets/images/logo_maze.png');
var logo_kidspeak = require('../assets/images/logo_kidspeak.png');
var logo_slashtest = require('../assets/images/logo_slashtest.png');
var logo_wordmark = require('../assets/images/logo_wordmark.png');
var logo_ideasthatwork = require('../assets/images/logo-bottom.png');


class AboutComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showIntro: false
        };

        this.showIntro = this.showIntro.bind(this);
        this.hideIntro = this.hideIntro.bind(this);
        this.handleIntro = this.handleIntro.bind(this);
    }

    showIntro(){
        this.setState({showIntro: true});
    }

    hideIntro(){
        this.setState({showIntro: false});
    }

    handleIntro(){
        if(this.state.showIntro){
            this.hideIntro();
        }else{
            this.showIntro();
        }
    }


    setUser = (user) => {
        this.props.callback(user);
    }

    render() {
        return (
            <div>
                <Header currentItem = {"About"}/>
                {this.state.showIntro? <Login callback={this.setUser} /> : null}
                <Games handleIntro = {this.handleIntro}/>
            </div>
        )
    }
}

class Login extends Component {

    setUser = (user) => {
        this.props.callback(user);
    }

    render() {
        return (
            <div>
                <div className="section bgGreen">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>What is Avenue: PM?</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9 aboutDescription">
                                <p>Progress monitoring was designed for students who are Deaf or Hard of Hearing (DHH) and students with language differences. The software may be used with all students.</p>
                                <p>Eight tasks track students’ progress from early reading through sixth grade beginning with picture naming, and word recognition to slash, maze, story retell and writing measures. Selected tasks include gaming elements and are designed to include students who communicate using American Sign Language and/or spoken English.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class Description extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showData: this.props.showData
        };
    }

    componentDidMount() {

    }

    render() {
        let gradingDescription = "";
        if (this.props.showData === 1) {
            gradingDescription = '<p>Picture Naming is a task designed for students who are just starting to develop their language skills in ASL or English. The student is shown a randomly selected  illustration and prompted to  say or sign the name of the picture. Teachers have a choice of using picture cards and scoring the student’s response on the computer, or having the student’s response video recorded and scoring later.  Picture naming is an indication that language is increasing weekly! ( For more detailed information, please see the Resources page.) </p>'
        } else if (this.props.showData === 2) {
            gradingDescription = '<p>Word SignSay is a task that indicates the  student’s fluency with high frequency English words. The student  is shown a randomly selected isolated word for 3 seconds and prompted to say, sign or Cue the word. The student’s response is recorded and sent to the teacher for scoring. Word SignSign is an indicator of a student’s familiarity with high frequency words.  ( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 3) {
            gradingDescription = '<p>CopyRight is a measure of a student’s short term recall of ASL.  The student  views a video of randomly selected ASL phrases and is prompted to copy or repeat the ASL story. The student’s signing is recorded and sent to the teacher.  Key items are scored as correct or incorrect. The number of correct items is automatically recorded and graphed. CopyRight is an aid in determining a student’s readiness for working with an interpreter in the classroom as well as comprehension of short ASL stories. ( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 4) {
            gradingDescription = '<p>SLASH is a task where the student is presented with a block of text, however the text has no spaces! The student reads the passage and marks where the spaces should be to create meaningful words and sentences. The task is automatically graded at the end of each passage giving the student immediate feedback. The student can see the score, goals, and what is needed to unlock new levels. SLASH is a measure a student’s comprehension of language patterns, semantic complexity, and using words in context. ( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 5) {
            gradingDescription = '<p>Kid Sign/Say is a task developed to identify a student’s skills in comprehension of English text and  translating the main ideas into American Sign Language.  The student views an English text passage displayed on the screen and  is prompted to retell the story is sign language. The student\'s signed story retell is recorded and saved. The student can watch the recording, try again, or submit the recording to the teacher.   AvePM records the scores  and shows the teacher  student’s progress across levels. ( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 6) {
            gradingDescription = '<p>AvePM KidSpeak is an e-verison of a common progress monitoring indicator-oral reading fluency and comprehension. Students see a text-based passage on the screen and are asked to read it aloud.  The recording is saved and sent to the teacher/teacher’s aid to score. Scoring is easy, quick and AvePM collects the results and graphs them for the teacher. Students can use KidSpeak independently. ( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 7) {
            gradingDescription = '<p>AvePM MAZE is an e-version of a common progress monitoring maze task.  The  student has one minute to read a story where every 7th word is deleted.  Each deleted word is replaced with  a multiple choice of 3 words. The student selects the word that best completes the story. The task is automatically scored and graphed.  Students, teachers and parents can see  progress weekly or monthly throughout the school year. The data can be used to identify the present level of performance and set IEP goals.( For more detailed information, please see the Resources page.)</p>';
        } else if (this.props.showData === 8) {
            gradingDescription = '<p>AvePM’s WordMark can be used to monitor a student’s progress in writing. Students are given a randomly selected story prompt  and  one minute to think about the topic and three minutes to type the story. The story is saved and sent to the teacher for scoring. Scoring is based on CBM rules: number of words written, number of correct word sequences, and number of incorrect word sequences. The scores are graphed and the student and teacher can monitor progress. ( For more detailed information, please see the Resources page.) </p>';
        }
        return (
            <div className={"aboutDescription"}
                 dangerouslySetInnerHTML={{__html: gradingDescription}}></div>

        )
    }
}

class Games extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showData: 1,
            showMore: false,
            showMoreText: 'More Info'
        };
    }

    componentDidMount() {
      this.handleSelect(1);
    }

    handleShowMore(){
        if(this.state.showMore){
            this.setState({ showMore: false});
            this.setState({ showMoreText: 'More Info'});
        }else{
            this.setState({ showMore: true});
            this.setState({ showMoreText: 'Less Info'});
        }

    }

    handleSelect(tabNum){
        this.setState({ showData: tabNum });
        this.setState({ showMore: false});
        this.setState({ showMoreText: 'More Info'});
    }

    render() {
        let items = null;
        let gradingTitle, videoURL;
        if (this.state.showData === 1) {
            gradingTitle = "Picture Naming";
            videoURL = "PN+intro.mp4";
        }
        else if (this.state.showData === 2){
            gradingTitle = "Word Sign/Sign";
            videoURL = "WSS+intro.mp4";
        }
        else if (this.state.showData === 3){
            gradingTitle = "CopyRight";
            videoURL = "CopyRight+intro.mp4";
        }
        else if (this.state.showData === 4){
            gradingTitle = "Slash";
            videoURL = "Slash+intro.mp4";
        }
        else if (this.state.showData === 5){
            gradingTitle = "Kid Sign/Say";
            videoURL = "KidSign+intro.mp4";
        }
        else if (this.state.showData === 6){
            gradingTitle = "KidSpeak";
            videoURL = "KidSpeak+intro.mp4";
        }
        else if (this.state.showData === 7){
            gradingTitle = "MAZE";
            videoURL = "Maze+intro.mp4";
        }
        else if (this.state.showData === 8){
            gradingTitle = "Word Mark";
            videoURL = "WordMark+intro.mp4";
        }
        return (
            <div>
                <div className="section bgYellow">
                    <div className="container">
                        <div className="row">
                            <div className="pull-right">
                                <button className="btn" onClick={this.props.handleIntro}> What is AvenuePM</button>
                            </div>
                            <div className="col-lg-12">
                                <h2>The Apps</h2>
                                <p>(Click on each app icon to learn more about them)</p>
                                <ul className="nav nav-pills pill">
                                    <li className={this.state.showData===1 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(1)}>
                                            <img src={logo_picturenaming} alt="Picture Naming" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===2 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(2)}>
                                            <img src={logo_wordsignsay} alt="Word Sign/Say" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===3 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(3)}>
                                            <img src={logo_copyright} alt="Copy Right" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===4 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(4)}>
                                            <img src={logo_slashtest} alt="Slash" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===5 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(5)}>
                                            <img src={logo_kidsign} alt="KidSign" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===6 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(6)}>
                                            <img src={logo_kidspeak} alt="Kid Speak" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===7 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(7)}>
                                            <img src={logo_maze} alt="MAZE" border="0" />
                                        </a>
                                    </li>
                                    <li className={this.state.showData===8 ? "active" : ""}>
                                        <a data-toggle="pill" onClick={(e) => this.handleSelect(8)}>
                                            <img src={logo_wordmark} alt="Word Mark" border="0" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="tab-content">
                                <div id="tab_maze" className="tab-pane fade in active">
                                    <div className="arrow-down arrowYellow"></div>
                                    <div className="col-md-9">
                                        <h3 style={{fontSize: 30}}>{gradingTitle}</h3>
                                        <div className={"col-xs-12 centerBlock"}>
                                            <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploadbeta/video/intro/"+videoURL} appName={"intro"} play={false}/>
                                        </div>
                                        <button onClick={(e) => this.handleShowMore()} name="Login" className="btn btn-primary btn-block" style={{textAlign:'center'}}>{this.state.showMoreText}</button>
                                        { this.state.showMore ? <Description showData={this.state.showData}/> : null }
                                    </div>
                                    <div className="col-md-3">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <footer className="bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p style={{textAlign:'left'}}>This website was developed by the avenuePM team pursuant to Cooperative Agreement CFDA H327S170012 with the Office of Special Education Programs, United States Department of Education, Project Officer name, Project Officer. The opinions expressed and materials contained herein do not necessarily reflect the position or policy of the United States Department of Education and you should not assume endorsement by the Federal Government.</p>
                                <p>&copy;
                        <script>new Date().getFullYear() > 2010 && document.write(new Date().getFullYear());</script> Designed and developed by researchers at the University of Minnesota and Penn State University.(v.3.0.32)</p>
                                <img src={logo_ideasthatwork} alt="Ideas That Work. U.S. Office of Special Education Programs" border="0" />
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        )
    }
}

export default AboutComponent;


// WEBPACK FOOTER //
// ./src/AboutComponent/About.js